/**
 * sitePageNormalizer — Converte valores do formulário SiteForm para o shape canônico
 * SiteConfigDto (§6.2 do plano de evolução).
 *
 * Garante:
 * - schemaVersion sempre 2.
 * - IDs dos blocos preservados (O8) — gerados uma única vez via crypto.randomUUID() no add.
 * - Defaults explícitos para todos os campos opcionais (O7).
 *
 * Blocks são armazenados no próprio formulário RHF (formValues.blocks) pelo SiteForm.
 *
 * @param {object} formValues - valores do react-hook-form incluindo blocks[]
 * @returns {object} SiteConfigDto pronto para PUT /pages/{id}/draft
 */
export function normalizeSiteConfig(formValues) {
  const {
    siteType,
    layoutTemplateId,
    layoutMode = 'continuous',
    seo = {},
    customStyles = {},
    scope = {},
    identity = {},
    blocks = [],
  } = formValues;

  return {
    schemaVersion: 2,
    siteType,
    layoutTemplateId: layoutTemplateId ?? null,
    layoutMode,
    seo: {
      title: seo.title ?? '',
      description: seo.description ?? '',
      ogImageUrl: seo.ogImageUrl ?? null,
    },
    customStyles: {
      primaryColor: customStyles.primaryColor ?? '#1976d2',
      backgroundColor: customStyles.backgroundColor ?? '#ffffff',
      textColor: customStyles.textColor ?? '#212121',
      accentColor: customStyles.accentColor ?? '#f50057',
      fontFamily: customStyles.fontFamily ?? 'Inter',
      fontSize: customStyles.fontSize ?? 'medium',
      borderRadius: customStyles.borderRadius ?? 'soft',
    },
    scope: {
      professionalId: scope.professionalId ?? null,
      placeId: scope.placeId ?? null,
      // scheduleIds REMOVIDO — agendas vivem nos blocos
      // placeIds REMOVIDO — seleção explícita via placeId
    },
    identity: {
      avatarUrl: identity.avatarUrl ?? null,
      avatarShape: identity.avatarShape ?? 'round',
    },
    // IDs preservados (O8) — cada bloco tem UUID estável atribuído no momento do add (crypto.randomUUID)
    blocks: blocks.map((block) => {
      const base = {
        id: block.id,
        type: block.type,
        enabled: block.enabled ?? true,
        order: block.order ?? 0,
        config: block.config ?? {},
      };

      if (block.type !== 'services') return base;

      const items = Array.isArray(base.config.items) ? base.config.items : [];
      return {
        ...base,
        config: {
          ...base.config,
          items: items.map((item) => {
            const showPrice = typeof item?.showPrice === 'boolean' ? item.showPrice : !!item?.price;
            return {
              ...item,
              showPrice,
              price: showPrice ? (item?.price ?? null) : null,
            };
          }),
        },
      };
    }),
  };
}

export default normalizeSiteConfig;
